import { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './store/authStore'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Admin from './pages/Admin'
import Settings from './pages/Settings'
import Chats from './pages/Chats'
import Contacts from './pages/Contacts'
import Calendar from './pages/Calendar'
import Tasks from './pages/Tasks'
import Export from './pages/Export'
import Statistics from './pages/Statistics'
import Broadcasts from './pages/Broadcasts'
import SMTPSettings from './pages/email/SMTPSettings'
import EmailCampaigns from './pages/email/Campaigns'
import Layout from './components/Layout/Layout'

function App() {
    const { isAuthenticated, user, fetchUser } = useAuthStore()

    useEffect(() => {
        if (isAuthenticated) {
            fetchUser().catch(console.error)
        }
    }, [isAuthenticated, fetchUser])

    if (!isAuthenticated) {
        return (
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
        )
    }

    return (
        <Layout>
            <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/chats" element={<Chats />} />
                <Route path="/contacts" element={<Contacts />} />
                <Route path="/calendar" element={<Calendar />} />
                <Route path="/tasks" element={<Tasks />} />
                <Route path="/broadcasts" element={<Broadcasts />} />

                <Route path="/email/campaigns" element={<EmailCampaigns />} />
                <Route path="/export" element={<Export />} />
                <Route path="/statistics" element={<Statistics />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/admin/*" element={<Admin />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Layout>
    )
}

export default App

